import React from 'react';
import classnames from 'classnames';
import SVG from './SVGWrapper';
import { alertColorMap } from '@repo/utils/models/SystemAlert';
import { SVGProps, SystemAlertSeverity } from '@repo/utils/types';

const ExclamationPt = () => (
  <>
    <path strokeLinecap="round" strokeWidth="1.3" d="M8 5.6v2.7" />
    <circle stroke="none" cx="8" cy="10.4" r="0.65" />
  </>
);

export const LowAlertIcon = ({ width = 16, height = 16, ...props }: SVGProps) => (
  <SVG
    {...{ ...props, width, height, customColor: alertColorMap.low }}
    className={classnames('alert-icon', props.className)}
    viewBox="0 0 16 16"
  >
    <circle fill="none" strokeWidth="1.15" cx="8" cy="8" r="6" />
    <ExclamationPt />
  </SVG>
);

export const MedAlertIcon = ({ width = 16, height = 16, ...props }: SVGProps) => (
  <SVG
    {...{ ...props, width, height, customColor: alertColorMap.medium }}
    className={classnames('alert-icon', props.className)}
    viewBox="0 0 16 16"
  >
    <rect
      fill="none"
      transform="rotate(45, 8, 8)"
      strokeWidth="1.1"
      x="3"
      y="3"
      width="10"
      height="10"
      rx="2"
    />
    <ExclamationPt />
  </SVG>
);

export const HighAlertIcon = ({ width = 16, height = 16, ...props }: SVGProps) => (
  <SVG
    {...{ ...props, width, height, customColor: alertColorMap.high }}
    className={classnames('alert-icon', props.className)}
    viewBox="0 -1 16 16"
  >
    <path
      fill="none"
      d="M8,1.57 C8.2,1.57 8.39,1.62 8.56,1.72 C8.73,1.82 8.88,1.97 8.98,2.16 L8.98,2.16 L13.78,10.67 C13.88,10.86 13.93,11.06 13.93,11.25 C13.93,11.59 13.83,11.9 13.61,12.12 C13.41,12.32 13.13,12.43 12.78,12.43 L12.78,12.43 L3.22,12.43 C2.87,12.43 2.59,12.32 2.39,12.12 C2.17,11.9 2.07,11.59 2.07,11.25 C2.07,11.06 2.12,10.86 2.22,10.67 L2.22,10.67 L7.02,2.16 C7.12,1.97 7.27,1.82 7.44,1.72 C7.61,1.62 7.81,1.57 8,1.57 Z"
      strokeWidth="1.15"
    ></path>
    <ExclamationPt />
  </SVG>
);

const alertIconMap: { [K in SystemAlertSeverity]: (props: SVGProps) => JSX.Element } = {
  low: LowAlertIcon,
  medium: MedAlertIcon,
  high: HighAlertIcon,
};

export default alertIconMap;
